import { formatDataTest } from '@/common/dataTest/DataTest';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { useTheme } from '@emotion/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, ListItemText, MenuItem } from '@mui/material';
import { useGridMenuItem } from 'ag-grid-react';

export const ContextMenu = ({ disabled, name, icon, action, subMenu }) => {

  useGridMenuItem({
    configureDefaults: () => true
  })

  const theme = useTheme();

  return (
    <Box>
      <MenuItem
        data-test-id={formatDataTest('context-menu-item', name)}
        dense
        disabled={disabled}
      >
        <Box sx={{ mr: 1 }}>
          {icon && <FontAwesomeIcon icon={icon} color={theme.palette.text.primary} fixedWidth />}
        </Box>
        <ListItemText>{name}</ListItemText>

        <Box sx={{ ml: 2 }}>
          {subMenu && <FontAwesomeIcon icon={fas.faAngleRight} size="sm" color={theme.palette.text.secondary} />}
        </Box>

        {/* <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          {subMenu ? ">" : " "}
        </Typography> */}
      </MenuItem>
    </Box>
  );
}
